import { Label as LabelPrimitive, LabelProps as LabelPrimitiveProps } from "react-aria-components";

import { Typography } from "@/components/Typography/Typography";

import styles from "./InputLabel.module.scss";

export interface AstreriskProps {
  /**
   * Whether the asterisk is visible. Did not use isRequired prop in text fields as some required fields do not need to show the asterisk.
   */
  showAsterisk?: boolean;
}

export type InputLabelProps = LabelPrimitiveProps & AstreriskProps;

const InputLabel = /*#__PURE__*/ (function () {
  const InputLabel: React.FC<InputLabelProps> = ({ children, showAsterisk, ...rest }) => {
    return (
      <LabelPrimitive {...rest} className={styles.inputLabel}>
        <Typography variant="l1">
          {children}
          {showAsterisk && <span className={styles.asterisk}>*</span>}
        </Typography>
      </LabelPrimitive>
    );
  };
  InputLabel.displayName = "InputLabel";
  return InputLabel;
})();

export { InputLabel };
